import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { AlertTriangleIcon } from "lucide-react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    ineligibleCount: number;
    onContinue: () => void;
}

export default function RestoreCandidatesValidationDialog({
    isOpen,
    onClose,
    ineligibleCount,
    onContinue,
}: Props) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/30">
                            <AlertTriangleIcon className="w-5 h-5 text-amber-600 dark:text-amber-400" />
                        </div>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            Some candidates weren't moved
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                        <span className="font-semibold text-gray-900 dark:text-gray-100">
                            {ineligibleCount}
                        </span>{" "}
                        <span className="font-semibold text-gray-900 dark:text-gray-100">
                            selected candidate{ineligibleCount !== 1 ? "s" : ""}
                        </span>{" "}
                        {ineligibleCount !== 1 ? "are" : "is"} not eligible to be moved,
                        hence {ineligibleCount !== 1 ? "they" : "it"} will stay in the{" "}
                        <span className="font-semibold text-gray-900 dark:text-gray-100">
                            Closed
                        </span>{" "}
                        tab.
                    </DialogDescription>
                </DialogHeader>

                <div className="flex justify-end gap-3 mt-4">
                    <Button
                        onClick={() => {
                            onContinue();
                            onClose();
                        }}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Continue
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
